import { render, staticRenderFns } from "./InventoryForecastSettings.vue?vue&type=template&id=4685f650&scoped=true"
import script from "./InventoryForecastSettings.vue?vue&type=script&lang=ts"
export * from "./InventoryForecastSettings.vue?vue&type=script&lang=ts"
import style0 from "./InventoryForecastSettings.vue?vue&type=style&index=0&id=4685f650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685f650",
  null
  
)

export default component.exports